import { IconButton } from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { Application } from "@store/types";
import React from "react";
import { Table } from "../../../../../../components";
import { Access } from "../../../../../../context";

type Props = {
  accesses: Access[];
  application: Application;
  onRemove: (access: Access) => void;
};

export const AccessList: React.FC<Props> = (props) => {
  const columns = React.useMemo(() => {
    return props.application.manual
      ? [
          { label: "Infra App" },
          { label: "Environment" },
          { label: "Device / Server / Database / Network Name" },
          { label: "Role" },
          { label: "Details" },
          { label: "Clasification" },
          { label: "Remove", width: "80px" },
        ]
      : props.application.lz
      ? [
          { label: "Role" },
          { label: "Details" },
          { label: "Clasification" },
          { label: "Remove", width: "80px" },
        ]
      : [
          { label: "Environment" },
          { label: "Role" },
          { label: "Details" },
          { label: "Clasification" },
          { label: "Remove", width: "80px" },
        ];
  }, [props.application]);

  // Helpers

  function getRowKey(access: Access) {
    return `${access.environment?.name}:${access.role?.name}`;
  }

  function getRowColumns(access: Access): string[] {
    return props.application.manual
      ? [
          access.infrastructureApplication?.name || "",
          access.environment?.name || "",
          access.subCategoryName || "",
          access.role?.name || "",
          access.accessDetails || "",
          props.application.categoryType || "",
        ]
      : props.application.lz
      ? [
          access.role.name || "",
          access.accessDetails || "",
          props.application.categoryType || "",
        ]
      : [
          access.environment?.name || "",
          access.role?.name || "",
          access.accessDetails || "",
          props.application.categoryType || "",
        ];
  }

  return (
    <Table columns={columns} rowHeight={43}>
      {props.accesses.map((access, index) => (
        <Table.Row key={getRowKey(access)}>
          {getRowColumns(access).map((column, index) => (
            <Table.Cell key={index}>{column}</Table.Cell>
          ))}
          <Table.Cell>
            <IconButton size="small" onClick={() => props.onRemove(access)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table>
  );
};
